import React, {useEffect, useState} from 'react';
import UtilsFunctions from "../../../utils/UtilsFunctions";
import Loader from "../../Loader";

const AdvertisingCampaignTable = ({sendData, setSendData, tableLoader}) => {

  const [componentData, setComponentData] = useState([])
  const [defaultChecked, setDefaultChecked] = useState(true)

  useEffect(() => {
    setComponentData(sendData?.campaignDetail)
  }, [sendData]);

  const rowClickHandler = (data) => {
    let temp = [...componentData];
    temp.forEach((item) => {
      if (item?.uniqId === data.uniqId) {
        item.checked = !data.checked;
      }
    })
    setComponentData(temp)
    setDefaultChecked(false)
  }

  const checkAllHandel = (target) => {
    let temp = [...sendData?.campaignDetail]
    temp.forEach((item) => {
      item.checked = target.checked;
    })
    setSendData({...sendData, campaignDetail: temp})
    setDefaultChecked(target.checked)
  }

  const inputHandler = (value, name, data) => {
    let temp = [...sendData?.campaignDetail]
    if (name === "percent") {
      if (+value <= 100) {
        temp.forEach((item) => {
          if (item?.uniqId === data.uniqId) {
            item.percent = value
          }
        })
      }
    } else if (name === "amount") {
      if (!isNaN(UtilsFunctions.removeCommas(value)) && +UtilsFunctions.removeCommas(value) <= +data?.productPrice) {
        temp.forEach((item) => {
          if (item?.uniqId === data.uniqId) {
            item.amount = UtilsFunctions.removeCommas(value)
          }
        })
      }
    }
    setSendData({...sendData, campaignDetail: temp})
  }

  try {
    return (
      <>
        {tableLoader ?
          <div className={"AdvertisingCampaignTable"}>
            {componentData?.length > 0 &&
              <ul>
                <li className={"header-class"}>
                  <div style={{width: "4%", borderRadius: "0 10px 0 0"}} className="check-box-cell">
                    <label className="container">
                      <input type="checkbox" checked={defaultChecked} onChange={(e) => checkAllHandel(e.target)}/>
                      <div className="checkmark"></div>
                    </label>
                  </div>
                  <div style={{width: "36%"}}>نام محصول</div>
                  <div style={{width: "20%"}}>قیمت قبل از تخفیف</div>
                  <div style={{width: "20%"}}>{sendData?.discountType === "percent" ? "درصد تخفیف" : "مبلغ تخفیف"}</div>
                  <div style={{width: "20%", borderRadius: "10px 0 0 0"}}>قیمت بعد از تخفیف</div>
                </li>
              </ul>
            }

            <ul className={"body-ul"}>
              {componentData?.length > 0 && componentData?.map(((item, index) =>
                  <li key={index + "row"}>
                    <div style={{width: "4%"}} className="check-box-cell">
                      <label className="container">
                        <input type="checkbox" checked={item?.checked}/>
                        <div className="checkmark"></div>
                      </label>
                    </div>
                    <div style={{width: "36%"}} onClick={() => rowClickHandler(item)}>{item?.productName}</div>
                    <div style={{width: "20%"}}
                         onClick={() => rowClickHandler(item)}>{UtilsFunctions.addCommas(item?.productPrice)}</div>
                    <div style={{width: "20%"}} className={"input-body"}>
                      {sendData?.discountType === "percent" ?
                        <input value={item?.percent} type={"number"}
                               onChange={(e) => inputHandler(e.target.value, "percent", item)}/> :
                        <input value={UtilsFunctions.addCommas(item?.amount)}
                               onChange={(e) => inputHandler(e.target.value, "amount", item)}/>}
                    </div>
                    <div style={{width: "20%"}} onClick={() => rowClickHandler(item)}>{item?.insuranceType}
                      {sendData?.discountType === "percent" ? UtilsFunctions.addCommas(+item?.productPrice - ((+item?.percent * +item?.productPrice) / 100)) :
                        UtilsFunctions.addCommas(+item?.productPrice - +item?.amount)}
                    </div>
                  </li>
              ))}
            </ul>
          </div> : <Loader/>}
      </>
    );
  } catch (e) {
    return <>{e.toLocaleString()}</>
  }
};

export default AdvertisingCampaignTable;